import React, { useContext } from 'react';
import { CompanyData } from '../../../App'
import { API_ENDPOINT } from '../../../AppConfig'
import ReactImageFallback from "react-image-fallback";
import avatar from '../../../Assets/Images/avatar.jpg'

function Banners(props) {
  const { data } = useContext(CompanyData)

  return (
    <div className="Banners text-center">
      <div className="container-fluid">
        <div className="row">
          {data && data.advertisements.map((element, index) => {
            return (
              <div className="col-lg-6 col-md-6 col-sm-12">
                <div>
                  <ReactImageFallback
                    src={`${API_ENDPOINT}${element}`}
                    fallbackImage={avatar}
                    initialImage={avatar}
                    style={{width:props.width?props.width:"" }}
                    alt={`banner_${index}`} />
                </div>
              </div>
            )
          })}
        </div>
      </div>
    </div>
  );
}

export default Banners;
